























import { Vue, Component, Prop } from 'vue-property-decorator';
import { chunkArrayInGroups } from '../utils/chunkArrayInGroups';
import ClickOutside from '../directives/ClickOutside';
import VIcon from './VIcon.vue';

@Component({
  directives: {
    ClickOutside
  },
  components: {
    VIcon
  }
})
export default class VColorPicker extends Vue {
  @Prop({ default: [] }) readonly colors!: string[];
  @Prop({ default: '#ff0000' }) readonly color!: string;
  @Prop({ default: 1 }) readonly columns!: number;

  created() {
    this.currentColor = this.color;
  }

  open = false;
  currentColor = '';

  closeDropdown() {
    this.open = false;
  }

  onColorClick(color: string) {
    this.currentColor = color;
    this.$emit('change', color);
  }

  get colorChunks() {
    return chunkArrayInGroups(this.colors, this.columns);
  }
}
